import {NotificationsAPI} from "../api/NotificationsAPI"
import {AppStore} from "../desktop"
import {actionNotificationFetchAllCompleted, actionNotificationFetchCompleted} from "../store/notifications/actions"
import {BaseService} from "./BaseService"
import {Notification} from "../models/Notification"
import {NotificationsActionTypes} from "../store/notifications"
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions"
import {ErrorService} from "./ErrorService"
import {TabTypes} from "../tabs/Tab"
import {actionToastrInfo} from "../store/global";

export default class NotificationsService extends BaseService {

	static getAll() {

        let notificationsAPI: NotificationsAPI = new NotificationsAPI()

		notificationsAPI.getAll().then(NotificationsService.processResponse)
		.then((result) => actionNotificationFetchAllCompleted(NotificationsService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(notification: Notification) {

        let notificationsAPI: NotificationsAPI = new NotificationsAPI()

        notificationsAPI.get(notification).then(NotificationsService.processResponse).then(result => {
			actionNotificationFetchCompleted(NotificationsService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(notification: Notification) {

        let notificationsAPI: NotificationsAPI = new NotificationsAPI()

		if (notification.id) {
			notificationsAPI.put(NotificationsService.itemToRequest(notification)).then(NotificationsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: NotificationsActionTypes.SAVE_COMPLETED, payload: NotificationsService.fromAPIItem(data)
					})
					actionSetTabStateItem(NotificationsService.fromAPIItem(data))
					actionSetTabItem(NotificationsService.fromAPIItem(data))
					actionToastrInfo("Info", "Obaveštenje je uspešno snimljeno")
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			notificationsAPI.post(NotificationsService.itemToRequest(notification)).then(NotificationsService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: NotificationsActionTypes.SAVE_COMPLETED, payload: NotificationsService.fromAPIItem(data)
					})
					actionSetTabStateItem(NotificationsService.fromAPIItem(data))
					actionSetTabItem(NotificationsService.fromAPIItem(data))
					actionToastrInfo("Info", "Obaveštenje je uspešno snimljeno")
				}
			).catch(error => ErrorService.handleError(error))

		}

	}

	static delete(notification: Notification) {

        let notificationsAPI: NotificationsAPI = new NotificationsAPI()

		notificationsAPI.delete(NotificationsService.itemToRequest(notification)).then(NotificationsService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: NotificationsActionTypes.DELETE_COMPLETED, payload: notification
				})
				actionDeleteTabForItemId(notification.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(notifications: Notification[]) {

		let notificationsAPI: NotificationsAPI = new NotificationsAPI()
		let count = 0
		notifications.forEach(notification => {

			notificationsAPI.delete(NotificationsService.itemToRequest(notification)).then(NotificationsService.processResponse).then(
				(data) => {
					count++
					actionDeleteTabForItemId(notification.id)
					if(count === notifications.length)
						AppStore.dispatch({
							type: NotificationsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: notifications
						})
				}
			).catch(error => ErrorService.handleError(error))
		})

	}

	static markSeen(id: string) {

		let notificationsAPI: NotificationsAPI = new NotificationsAPI()

		notificationsAPI.markSeen(id).then(
			(data) => {
			}
		).catch(error => ErrorService.handleError(error))
	}

    static fromAPIList(apiList: any): Notification[] {
        const localList = apiList.map((apiItem: any) => NotificationsService.fromAPIItem(apiItem))
        //console.info('[fromAPINotificationList] converted notifications: ', localList)
        return localList
    }

    static fromAPIItem(apiItem: any): Notification{
        let notification = new Notification()

        notification.id = apiItem.id
        notification.title = apiItem.name
		notification.description = apiItem.description
		notification.seen = apiItem.seen
		notification.userId = apiItem.userId
		notification.action = apiItem.action
		notification.data = apiItem.data
		notification.createdAt = apiItem.createdAt

        return notification
    }

    static itemToRequest (notification: Notification): any {

		let itemRequest: any = {}

		if(notification.id)
        itemRequest.id = notification.id

		itemRequest.name = notification.title
		itemRequest.description = notification.description
		itemRequest.seen = notification.seen
		itemRequest.userId = notification.userId

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}

	static parseAction(notification: Notification): NotificationAction {
		if (notification.action) {
			const result = notification.action.split('=')
			if (result.length == 2) {
				const actionName = result[0]
				const actionId = result[1]
				switch (actionName) {
					case 'open_document':
						return {tabType: TabTypes.DOCUMENT_NEW, id: actionId}
					default:
						return null
				}
			}
		}
		return null
	}
}

export interface NotificationAction {
	tabType: TabTypes
	id: string
}
